import * as z from "zod";

export const getRecoverImessageMerchants = {
  name: "getRecoverImessageMerchants" as const,
  // Brands that send Recover over iMessage, on either pipeline: legacy
  // (settings.recover.iMessageEnabled) or Shopper-Agent Recover V2
  // (recoverConfig + shopperAgent.iMessageConfig). Independent of any A/B test.
  input: z.object({}),
  output: z.object({
    merchants: z.array(
      z.object({
        teamId: z.string(),
        teamName: z.string(),
        pipeline: z.enum(["legacy", "shopper_agent"]),
        // True when this brand's account has an active recover-surface
        // imessage_channel A/B test running.
        hasActiveTest: z.boolean(),
        activeTestName: z.string().nullable(),
      }),
    ),
  }),
};
